/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import store from '../state/store';

store.on('pending_tutor_proposals:add', function(params) {
  if (params == null) { params = {}; }
  const tutor_id = params.tutor.id;
  const tutoring_job_position_id = params.tutoring_job_position.id;

  if (_.any(store.get().tutor_proposals, tutor_proposal => (!_.isFinite(tutor_proposal.id)) && (tutor_proposal.tutor.id ===tutor_id) && (tutor_proposal.tutoring_job_position.id ===tutoring_job_position_id))) { return; }

  return store.get().tutor_proposals.push(params);
});

store.on('pending_tutor_proposals:remove', function(params) {
  if (params == null) { params = {}; }
  const { tutor_id } = params;
  const { tutoring_job_position_id } = params;

  const tutor_proposals = _.select(store.get().tutor_proposals, tutor_proposal => _.isFinite(tutor_proposal.id) || (tutor_proposal.tutor.id !==tutor_id) || (tutor_proposal.tutoring_job_position.id !==tutoring_job_position_id));

  return store.get().set({tutor_proposals});
});

store.on('pending_tutor_proposals:motivation:update', function(params) {
  if (params == null) { params = {}; }
  const tutor_id = params.tutor.id;
  const tutoring_job_position_id = params.tutoring_job_position.id;

  const tutor_proposal = _.first(_.select(store.get().tutor_proposals, tutor_proposal => (!_.isFinite(tutor_proposal.id)) && (tutor_proposal.tutor.id ===tutor_id) && (tutor_proposal.tutoring_job_position.id ===tutoring_job_position_id))
  );

  return tutor_proposal.set({motivation: params.motivation});
});

store.on('pending_tutor_proposals:remove_tutor', function(tutor_id) {
  const tutor_proposals = _.select(store.get().tutor_proposals, tutor_proposal => _.isFinite(tutor_proposal.id) || (tutor_proposal.tutor.id !==tutor_id));

  return store.get().set({tutor_proposals});
});